var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockTick = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clock-tick_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.838 13.088a.937.937 0 1 1 1.325 1.325l-3.75 3.75a.94.94 0 0 1-1.325 0l-1.668-1.667a.938.938 0 0 1 1.326-1.326l1.004 1.005zM9.062 5a.938.938 0 0 1 1.875 0v4.42l2.596 1.3.084.046a.938.938 0 0 1-.834 1.669l-.088-.038-3.116-1.558a.94.94 0 0 1-.517-.838zm8.332 5a7.396 7.396 0 1 0-7.961 7.375l.372.018.095.007a.938.938 0 0 1-.047 1.866l-.097.002-.466-.024a9.272 9.272 0 1 1 9.966-8.734.938.938 0 1 1-1.873-.103 8 8 0 0 0 .011-.406"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clock-tick_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgClockTick.displayName = "SvgClockTick";
export { SvgClockTick as ReactComponent };
export default SvgClockTick;